/**
 * 사주풀이 > 목차
 *
 * index로 id를 조회하기 때문에 id를 page라고 보면 됨
 */
export const CONTENTS = [
  { id: 1, title: '1. "사주, 이제는 나도 이해할 수 있어요"' },
  { id: 5, title: '2. 나는 어떤 사람일까?' },
  { id: 5, title: '3. 나의 일주 이야기' },
  { id: 6, title: '4. 나의 에너지는 어떤 모습?' },
  { id: 6, title: '5. 관계속에서의 내 스타일' },
  { id: 7, title: '6. 나의 성향과 스타일' },
  { id: 7, title: '7. 숨겨진 강점' },
  { id: 8, title: '8. 나의 유형카드' },
  { id: 8, title: '9. 인생의 에너지 흐름' },
];

/** 사주풀이 > 페이지네이션 > 목차 인덱스 - 페이지 매칭 */
export const CONTENTS_PAGE_MAP = {
  0: 1,
  1: 5,
  2: 5,
  3: 6,
  4: 6,
  5: 7,
  6: 7,
  7: 8,
  8: 8,
};
